<template>
    <div class="searchbar">
        <div class="tabs">
                <span v-for="(item,index) in tablist" :class="{active:istrue===index}" :key="index"
                      @click.stop="show(index)">{{item.tit}}</span>
        </div>
        <div class="ordinarySearch" v-show="!isshow">
            <div class="select" @mouseenter="enter" @mouseleave="leave">
                <span>{{showName}}<i class="el-icon-arrow-down"></i></span>
                <ul v-show="isshowName">
                    <li v-for="(item, index) in liList" :key="index" @click.stop="showName=item.name">
                        {{item.name}}
                    </li>
                </ul>
            </div>
            <el-input placeholder="请输入要查询的内容" v-model="ordinarySearchData" class="input-with-select">
                <el-button slot="append" @click="getSearchData">搜索</el-button>
            </el-input>
        </div>
        <div class="accurateSearch" v-show="isshow">
            <div class="box">
                <div class="left">
                    <el-input v-model="accurate.input1" placeholder="输入检测对象关键字"></el-input>
                    ---
                    <el-input v-model="accurate.input2" placeholder="输入项目检测关键字"></el-input>
                    ---
                    <el-input v-model="accurate.input3" placeholder="输入检测标准关键字"></el-input>
                    <el-button plain @click="getAccurateData">搜索</el-button>
                </div>
            </div>
            <div class="select" @mouseenter="enter" @mouseleave="leave">
                <span>{{showName}} <i class="el-icon-arrow-down"></i></span>
                <ul v-show="isshowName">
                    <li v-for="(item, index) in liList" :key="index" @click.stop="showName=item.name">
                        {{item.name}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'searchbar',
    data () {
      return {
        isshow: 0,
        tablist: [
          {tit: '普通搜索', show: true},
          {tit: '精准搜索', show: false}
        ],
        liList: [
          {name: '检验检测'},
          {name: '计量校准'}
        ],
        showName: '检验检测',
        isshowName: false,
        istrue: 0,
        searchData: '',
        ordinarySearchData: '',
        accurate: [
          {input1: ''},
          {input2: ''},
          {input3: ''}
        ],
        input: '',
        selectName: '检验检测'
      }
    },
    methods: {
      enter () {
        this.isshowName = true
      },
      leave () {
        this.isshowName = false
      },
      show (index) {
        this.istrue = index
        this.isshow = index
      },
      getSearchData () {
        const key = this.ordinarySearchData
        const data1 = this.showName
        if (key === '') {
          this.$message.error({
            message: '输入内容不能为空',
            type: 'error',
            center: true
          })
        } else {
          this.$store.commit('getData', key)
          this.$store.commit('getData1', data1)
          this.$router.push({name: 'SearchList'})
        }
      },
      getAccurateData () {
        // console.log(this.accurate)
        if (this.accurate.input1 === undefined && this.accurate.input2 === undefined && this.accurate.input3 === undefined) {
          this.$message.error({
            message: '输入内容不能为空',
            type: 'error',
            center: true
          })
        }
        const data = {
          name: this.accurate.input1,
          category: this.accurate.input2,
          standard: this.accurate.input3
        }
        this.$store.commit('getDataA', data)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/searchbar.vue